/* Perf: SliderComponent.update() read slide geometry (isSlideVisible, which
   reads offsetLeft/clientWidth) interleaved with prevButton/nextButton
   setAttribute('disabled', ...) writes, forcing a synchronous layout
   recalculation on every slider scroll/init. This patches the method after
   global.perf.min.js has defined it, computing both reads first and writing
   both attributes after — same resulting DOM state, no forced reflow.
   Applied as a separate file (not edited in the minified global.perf.min.js)
   so a hand-edit of that large shared bundle can't risk a syntax error. */
(function () {
  var SliderComponentClass = window.customElements && customElements.get('slider-component');
  if (!SliderComponentClass) return;

  SliderComponentClass.prototype.update = function () {
    if (!this.slider || !this.nextButton) return;

    var previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    var isPrevDisabled = this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0;
    var isNextDisabled = this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]);

    if (isPrevDisabled) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (isNextDisabled) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  };
})();
